module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "home"
  }, [_c('div', {
    staticClass: "center"
  }, [_vm._m(0), _vm._v(" "), _c('h3', [_vm._v("The fastest item manager for Destiny 2")]), _vm._v(" "), _c('a', {
    staticClass: "button shadow",
    on: {
      "click": _vm.login
    }
  }, [_vm._v("Please Authorize with Bungie.net to proceed.")])]), _vm._v(" "), _c('div', {
    staticClass: "center spread shadow"
  }, [_c('social-sharing', {
    attrs: {
      "url": "https://itemmanager.uk/",
      "title": "Item Manager for Destiny 2",
      "description": "Item manager allows you transfer your items between characters with one click",
      "quote": "The fastest item manager for Destiny 2.",
      "hashtags": "destiny,item,manager,vault",
      "twitter-user": "itemmanager"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', [_c('network', {
            attrs: {
              "network": "facebook"
            }
          }, [_c('i', {
            staticClass: "fa fa-facebook"
          }), _vm._v(" Facebook\n        ")]), _vm._v(" "), _c('network', {
            attrs: {
              "network": "googleplus"
            }
          }, [_c('i', {
            staticClass: "fa fa-google-plus"
          }), _vm._v(" Google +\n        ")]), _vm._v(" "), _c('network', {
            attrs: {
              "network": "email"
            }
          }, [_c('i', {
            staticClass: "fa fa-envelope"
          }), _vm._v(" Email\n        ")]), _vm._v(" "), _c('network', {
            attrs: {
              "network": "reddit"
            }
          }, [_c('i', {
            staticClass: "fa fa-reddit"
          }), _vm._v(" Reddit\n        ")]), _vm._v(" "), _c('network', {
            attrs: {
              "network": "twitter"
            }
          }, [_c('i', {
            staticClass: "fa fa-twitter"
          }), _vm._v(" Twitter\n        ")]), _vm._v(" "), _c('network', {
            attrs: {
              "network": "vk"
            }
          }, [_c('i', {
            staticClass: "fa fa-vk"
          }), _vm._v(" VKontakte\n        ")]), _vm._v(" "), _c('network', {
            attrs: {
              "network": "weibo"
            }
          }, [_c('i', {
            staticClass: "fa fa-weibo"
          }), _vm._v(" Weibo\n        ")]), _vm._v(" "), _c('network', {
            attrs: {
              "network": "whatsapp"
            }
          }, [_c('i', {
            staticClass: "fa fa-whatsapp"
          }), _vm._v(" Whatsapp\n        ")])], 1)
        
      },
      staticRenderFns: []
    }
  })], 1), _vm._v(" "), _c('img', {
    staticClass: "screen-shot",
    attrs: {
      "src": require("../../assets/screen.png")
    }
  }), _vm._v(" "), _c('help')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_vm._v("Welcome to the "), _c('strong', [_vm._v("Item Manager")]), _vm._v(".")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c96d4f36","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Home.vue
// module id = 569
// module chunks = 1